export function makeNumberArray(x, n) {
  let array = [];
  for (let i = x; i <= n; i++) {
    array.push(i);
  }
  return array;
}
